<template>
    <!-- layout -->
    <div class="page-wrapper">
      <!-- Header 표시 여부 제어 -->
      <MainHeader v-if="showHeader" />
      <!-- <Side v-if="isMain" /> -->
      <Content class="content" />
      <!-- Footer 표시 여부 제어 -->
      <MainFooter v-if="showFooter"/>
    </div>
  </template>
  
  <script>
  import MainHeader from '@/components/inc/header/MainHeader.vue'
  import MainFooter from '@/components/inc/footer/MainFooter.vue'
  import Content from '@/components/inc/content'
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  
  export default {
    components: {
        MainHeader,
        MainFooter,
        Content
    },
    setup() {
        const route = useRoute()
  
        // Header 표시 여부 결정
        const showHeader = computed(() => {
            const hiddenHeaderRoutes = [  'adminpage', 'adminmainpage', 'usermgmt', 'inquirymgmt', 'icikad' ]; 
            return !hiddenHeaderRoutes.includes(route.name); 
        });

        const showFooter = computed(() => {
            const hiddenFooterRoutes = [ 'adminpage', 'adminmainpage', 'usermgmt', 'inquirymgmt', 'icikad', 'aichat' ]; 
            return !hiddenFooterRoutes.includes(route.name); 
        });
        
  
        // // Footer 표시 여부 결정
        // const showFooter = computed(() => {
        //     const hiddenFooterRoutes = ['login','join', 'orgJoin','myPage',"joinType","findID","findPW",'Home',"organizationGiasStats"]; 
        //     return !hiddenFooterRoutes.includes(route.name); 
        // });
  
        const isMain = computed(() => {
            // 필요 시 스토어의 값을 활용해 Side 컴포넌트 표시 여부 결정
            return store.state.temp.isMain;
        });
  
        return {
            isMain,
            showHeader,
            showFooter
        }
    }
  }
  </script>
  <style scoped>
  
  
  /* .page-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    margin: 0 auto;
    background-color: #f4f4f4; 
    transition: background 0.3s ease;
  }
  
  .page-wrapper.home-layout {
    background: linear-gradient(180deg, #1F2D4D 0%, #24395C 100%);
    color: white; 
  }
  
  .content {
    flex: 1;
  } */
  </style>